/**
 * StudioNotices — the facilitator's notification pop-ups (#14–21), shown one
 * at a time while Studio is open, never in the drill console, and the list
 * they wait in behind the bell (Design's sketches, Nino OK 11 and 12 Oct).
 * The two go on together: a pop-up fades after 6 s into the bell's list.
 */
import { useSyncExternalStore } from 'react';
import { notificationApi } from '@/lib/api';
import { isLiveDrillOpen, onLiveDrillOpenChange } from '@/lib/authSession';
import { noticeTarget } from '@/lib/notices';
import type { FacilitatorPage } from '@/types/facilitator-portal';
import { NoticePopupLayer } from './NoticePopup';
import { useNoticePopups } from '../hooks/useNoticePopups';

export const NOTICES_ON = true;

export default function StudioNotices({ onNavigate, onOpenList }: { onNavigate: (page: FacilitatorPage) => void; onOpenList: () => void }) {
  const inConsole = useSyncExternalStore(onLiveDrillOpenChange, isLiveDrillOpen);
  const { step, folded, dismiss } = useNoticePopups(NOTICES_ON, inConsole);
  if (!step || inConsole) return null;
  const stepKey = step.kind === 'one' ? step.notice.id : step.ids.join('+');
  return (
    <NoticePopupLayer
      stepKey={stepKey}
      step={step}
      folded={folded}
      onDone={dismiss}
      canAct={(n) => noticeTarget(n.button) !== null}
      onAction={(n) => {
        const to = noticeTarget(n.button);
        if (!to) return;
        // Read is best-effort: if it fails, the list still shows it unread, which is the honest state.
        void notificationApi.markRead(n.id).catch(() => undefined);
        onNavigate(to.page);
      }}
      onOpenList={onOpenList}
    />
  );
}
